import { render } from "./LicenciaConducir.vue?vue&type=template&id=7b56d892"
import script from "./LicenciaConducir.vue?vue&type=script&lang=js"
export * from "./LicenciaConducir.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\esteb\\Desktop\\PlantillaEsteban\\fronted-plantilla\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__